export var DepositFormsExperience;
(function (DepositFormsExperience) {
    DepositFormsExperience["FALLBACK"] = "fallback";
    DepositFormsExperience["DIRECT"] = "direct";
    DepositFormsExperience["DISABLED"] = "disabled";
})(DepositFormsExperience || (DepositFormsExperience = {}));
export var DD_FORM_SIGNATURE_STYLES = [
    'homemade_apple',
    'sunshiney',
    'caveat',
];
